import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-soltermcondition',
  templateUrl: './soltermcondition.component.html',
  styleUrls: ['./soltermcondition.component.css']
})
export class SoltermconditionComponent implements OnInit {

   constructor(private router: Router) { }

  ngOnInit(): void {
  $(document).ready(function(){
  $('.sell').addClass('active');
  $('.sell a').css('color','#fff');
   $('.sell img').attr('src','./assets/image/icon/Sell.png');
  });
  }

   getCheckboxInput(){
  var Router=this.router;
  if($(".assetCheckboxInput").is(":checked")==true)
  {
    Router.navigate(['/solution']);
  }
  }

}
